import { useState, type ReactNode } from "react";

export function Section({
  title,
  defaultOpen = true,
  children,
}: {
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="rounded-lg border bg-white">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-5 py-3 text-left"
      >
        <span className="font-semibold text-sm">{title}</span>
        <span className="text-neutral-400 text-sm">{open ? "−" : "+"}</span>
      </button>
      {open && (
        <div className="border-t px-5 py-5 space-y-4">{children}</div>
      )}
    </section>
  );
}
